import React from 'react';

const CommentTypingIndicator: React.FC<{ label: string }> = ({ label }) => {
  if (!label) return null;
  return (
    <p className="tc-typing" role="status" aria-live="polite">
      {label.replace(/…$/, '')}
      <span className="tc-typing-ellipsis" aria-hidden>
        …
      </span>
    </p>
  );
};

export default CommentTypingIndicator;
